import React from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import CtaPanel from '../components/CtaPanel';
import { locations } from '../data/locations';
import { company } from '../data/company';
import './LandingPage.css';

function DeliveryAreas() {
  return (
    <div className="landing-page">
      <SEO />

      <PageHero
        breadcrumbs={[{ name: 'Delivery Areas', path: '/delivery-areas' }]}
        kicker="Delivery areas"
        bg="/images/bg-shopfront.jpg"
        title="Ceiling & Drywall Supplies Delivered From George"
        text={`From Plettenberg Bay to Cape Town and north into the Klein Karoo, ${company.name} delivers ceiling, drywall, insulation and acoustic supplies straight from our warehouse in Joubert Industria, George.`}
      />

      <section className="section section-white">
        <div className="container split">
          <img
            className="areas-hub-map"
            src="/South-Africa-Delivery-Routes.jpg"
            alt={`${company.name} delivery routes from George to Cape Town, Mossel Bay, Knysna, Tsitsikamma and Gqeberha`}
            width="725"
            height="484"
          />
          <div className="prose">
            <h2>Collect or have it delivered</h2>
            <p className="muted">
              Visit our showroom and warehouse at {company.address.street}, George, or choose your area below to see
              what we deliver there.
            </p>
            <p className="muted">
              Not listed? Call <a href={company.phones[0].href}>{company.phones[0].number}</a> — we also supply national
              customers throughout South Africa.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-light">
        <div className="container">
          <div className="area-card-grid">
            <div className="card area-card">
              <span className="area-card-region">Head office &amp; showroom</span>
              <h2 className="card-title">George</h2>
              <p className="card-text">
                Visit our showroom and warehouse at {company.address.street}, or have materials delivered anywhere in
                George.
              </p>
            </div>
            {locations.map((l) => (
              <div key={l.slug} className="card area-card">
                <span className="area-card-region">{l.region}</span>
                <h2 className="card-title">{l.name.replace(/^the /, '')}</h2>
                <p className="card-text">
                  Ceiling &amp; drywall supplies {l.distance}. Also {l.nearby.slice(0, 3).join(', ')}.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaPanel />
    </div>
  );
}

export default DeliveryAreas;
